import { Injectable } from '@angular/core';
import { UTCDate, UTCDateMini } from '@date-fns/utc';

@Injectable({
  providedIn: 'root',
})
export class TimeService {
  constructor() {}

  getNow(): Date {
    return new Date();
  }

  getUtcNow(): UTCDate {
    return new UTCDateMini();
  }

  getToday(): string {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${today.getFullYear()}-${month}-${day}`;
  }
}

